import { render, staticRenderFns } from "./productEdit.vue?vue&type=template&id=99350f98&"
import script from "./productEdit.vue?vue&type=script&lang=js&"
export * from "./productEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports